import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
    selector: 'app-checkbox-list',
    standalone: true,
    imports: [CheckboxModule, InputTextModule, FormsModule, NgClass, TooltipModule, TranslatePipe],
    templateUrl: './checkbox-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxListComponent {
    @Input() items: any[] = [];
    @Input() labelKey = '';
    @Input() checkedKey = 'checked';

    @Input() showSearch = true;
    @Input() showSelectAll = false;
    @Input() searchPlaceholder = 'Search';
    @Input() disabledKey = '';
    @Input() disabledTooltipFn: ((item: any) => string) | null = null;

    @Input() showMoreEnabled = false;
    @Input() allLoaded = false;
    @Input() loadMoreError = false;

    @Input() badgeKey = '';

    @Output() selectionChange = new EventEmitter<{ item: any; checked: boolean }>();
    @Output() selectAllChange = new EventEmitter<boolean>();
    @Output() searchChange = new EventEmitter<string>();
    @Output() loadMore = new EventEmitter<void>();

    searchTerm = '';
    loadingState = false;
    loadingTimer: any;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['items'] || changes['loadMoreError'] || changes['allLoaded']) {
            this.loadingState = false;
        }
    }

    get allSelected(): boolean {
        if (!this.items?.length) return false;
        return this.items.every((item) => item[this.checkedKey] === true);
    }

    onSearch(event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        this.searchTerm = value;
        this.searchChange.emit(value);
    }

    onToggle(item: any): void {
        this.selectionChange.emit({ item, checked: item[this.checkedKey] });
    }

    onSelectAll(checked: boolean): void {
        this.selectAllChange.emit(checked);
    }

    onShowMore(): void {
        this.loadMore.emit();
        this.loadingState = true;
    }

    getTooltip(item: any): string {
        if (this.disabledTooltipFn && this.isDisabled(item)) {
            return this.disabledTooltipFn(item);
        }
        return item[this.labelKey];
    }

    isDisabled(item: any): boolean {
        return !!this.disabledKey && !!item[this.disabledKey];
    }
}
